import React from 'react';
import './RefreshLoadingModal.css';

function StepIcon({ status, stepNumber, iconMode = 'default' }) {
  if (iconMode === 'number' && stepNumber != null) {
    return (
      <span
        className={`refresh-loading-step-number refresh-loading-step-number--${status}`}
        aria-hidden
      >
        {stepNumber}
      </span>
    );
  }

  if (status === 'done') {
    return (
      <span className="refresh-loading-step-icon refresh-loading-step-icon--done" aria-hidden>
        <svg viewBox="0 0 16 16" width="12" height="12" fill="none">
          <path
            d="M3.5 8.2L6.4 11l6.1-6.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    );
  }

  if (status === 'active') {
    return (
      <span className="refresh-loading-step-icon refresh-loading-step-icon--active" aria-hidden />
    );
  }

  if (status === 'error') {
    return (
      <span className="refresh-loading-step-icon refresh-loading-step-icon--error" aria-hidden>
        <svg viewBox="0 0 16 16" width="11" height="11" fill="none">
          <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
    );
  }

  return (
    <span className="refresh-loading-step-icon refresh-loading-step-icon--pending" aria-hidden>
      <svg viewBox="0 0 16 16" width="11" height="11" fill="none">
        <path
          d="M3.5 8.2L6.4 11l6.1-6.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

/** status: 'done' | 'active' | 'pending' | 'error' */
export function LoadingStepsList({
  steps = [],
  className = '',
  iconMode = 'default',
}) {
  if (!steps.length) return null;

  return (
    <ul className={`refresh-loading-steps${className ? ` ${className}` : ''}`}>
      {steps.map((step, index) => {
        const status = step.status || 'pending';
        const stepNumber = step.stepNumber ?? index + 1;
        return (
          <li
            key={step.id || step.label}
            className={`refresh-loading-step refresh-loading-step--${status}`}
          >
            <StepIcon status={status} stepNumber={stepNumber} iconMode={iconMode} />
            <span className="refresh-loading-step-label">{step.label}</span>
          </li>
        );
      })}
    </ul>
  );
}

export function mapAppLoadingStepStatus(status) {
  switch (status) {
    case 'completed':
      return 'done';
    case 'loading':
      return 'active';
    case 'error':
      return 'error';
    case 'skipped':
    case 'pending':
    default:
      return 'pending';
  }
}

export default LoadingStepsList;
